






























































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import {
  DemoUserRosterName,
  DemoRosterState
} from "@/admin/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { FetchState } from "@/shared/types";
import { useDemoUsersStore } from "@/admin/store/demoUsers";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class DemoRoster extends Vue {
  newEmail = "";
  sortBy = "";
  sortDesc = false;
  $validator: Validator;

  @Prop({ required: true }) rosterName: DemoUserRosterName;
  @Prop({ required: true }) rosterState: DemoRosterState;

  demoUserStore = useDemoUsersStore();
  notifierStore = useNotifierStore();


  get isLoaded () {
    return this.rosterState.fetchState === FetchState.Loaded; // TODO be busy while updating roster!
  }

  get sectionTitle () {
    return this.rosterName === "openBrokerage" ? "Open-Brokerage Demo Users" : "RIA-Managed Demo Users";
  }

  userFields = [
    {
      key: "email",
      label: "Email Address",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      sortable: true,
    },
    {
      key: "firstName",
      label: "First Name",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      sortable: true,
    },
    {
      key: "lastName",
      label: "Last Name",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      sortable: true,
    },
    {
      key: "partnerName",
      label: "Partner",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      sortable: true,
    },
    {
      key: "custodianName",
      label: "Custodian",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      sortable: true,
    },
    {
      key: "remove",
      label: "",
      tdClass: "text-right",
      sortable: false,
    },
  ];

  get userTableItems () {
    if (!this.rosterState.roster) {
      return [];
    }

    return this.rosterState.roster.map(x => ({ ...x, remove: x.email }));
  }

  get newEmailIsInvalid () {
    return this.errors.has("new-email");
  }

  get rosterEmails () {
    return this.rosterState.roster.map(r => r.email);
  }

  saveRoster (emails: string[]) {
    return this.demoUserStore.putRoster({ rosterName: this.rosterName, emails });
  }

  onRemoveRecordClicked (email: string) {
    const emails = this.rosterEmails.filter(x => x !== email);
    this.saveRoster(emails);
  }

  onAddEmailClicked () {
    if (this.newEmailIsInvalid) {
      return;
    }

    // this.setEmailToBeAdded({email: this.newEmail, rosterName: this.rosterName});
    this.saveRoster(this.rosterEmails.concat([ this.newEmail ]))
        .then(_ => {
          if (this.demoUserStore.emailsNotFound.indexOf(this.newEmail) !== -1) {
            this.notifierStore.setWarning(`Could not find user with email: ${this.newEmail}`);
          } else {
            this.newEmail = "";
          }
        });
  }
}
